<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div class="editor-dialog">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center py-2 px-0">
          <span class="primary--text">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
      </div>
      <v-card-text class="pa-4">
        <label class="label-input">Section Name</label>
        <v-row>
          <v-col cols="12" md="8"><v-text-field v-model="fields.title" label="Name"/></v-col>
          <v-col cols="12" md="4"><v-checkbox v-model="fields.enableAnchor" label="Enable Anchor"/></v-col>
        </v-row>

        <label class="label-input">Header</label>
        <ckeditor :editor="editor" v-model="fields.header" :config="editorConfig" />

        <div class="mt-6">
          <label class="label-input">Timeline</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6" class="mt-3">
                <ColorPicker
                  v-model="fields.lineColor"
                  name="upairy-timeline-line-color"
                  label="Line and marker color"
                  default-color="#23873D"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="fields.lineWidth"
                  type="number"
                  min="1"
                  max="12"
                  label="Line width"
                  suffix="px"
                />
              </v-col>
            </v-row>
            <div class="d-flex justify-space-between align-center mb-4">
              <label class="label-input mb-0">Timeline items</label>
              <v-btn small color="primary" @click="handleAddItem"><v-icon size="16">mdi-plus</v-icon>Add Item</v-btn>
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.listItem" :key="'upairy-timeline-' + index">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center flex-grow-1">
                    <span>Item {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(index)"
                      ><v-icon color="#ff6c6c">mdi-delete</v-icon></v-btn
                    >
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <label class="d-block mb-2">Content</label>
                  <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mt-6">
          <label class="label-input">Image</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6"><v-checkbox v-model="fields.image.show" label="Show image" hide-details/></v-col>
              <v-col cols="12" md="6"
                ><v-select v-model="fields.image.position" :items="positionOptions" label="Image position"
              /></v-col>
            </v-row>
            <div v-if="fields.image.show" class="mt-4">
              <UploadImage
                :image="{ imageSrc: fields.image.src }"
                :height="'240'"
                :typeUpload="'image'"
                @callback="handleUploadImage"
                @callbackDelete="handleRemoveImage"
              />
              <v-text-field v-model="fields.image.alt" class="mt-4" label="Image alt" hide-details />
            </div>
          </div>
        </div>

        <SectionSettingsContainerFuild
          class="mt-6"
          :settings="fields.settings"
          :containerPage="fields.containerPage"
          :showBackgroundImage="false"
          :showContainerPage="false"
        />
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions class="py-2 px-0">
          <v-spacer />
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '../common/html/update';
import ColorPicker from './common/color-picker.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

const defaultImage = 'https://cdn.skyfastimg.com/images/2026/08/04/image-6a71b36bca9e6ff766d8e84d.webp?w=1000';

const defaultItem = () => ({
  content:
    '<p><span style="color:hsl( 0, 0%, 40% );">Week +</span></p><h2><span style="color:hsl(135,61%,31%);"><strong>Title</strong></span></h2><p>Content</p>',
});

export default {
  name: 'UpairyTimeline',
  components: { UploadImage, ColorPicker, SectionSettingsContainerFuild },
  props: { sectionEditor: { type: Object, required: true } },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      positionOptions: [
        { text: 'Left', value: 'left' },
        { text: 'Right', value: 'right' },
      ],
      fields: {
        title: 'Upairy timeline',
        enableAnchor: false,
        header: '',
        lineColor: '#23873D',
        lineWidth: 2,
        listItem: [],
        image: { show: true, position: 'right', src: defaultImage, alt: 'Potty training progress' },
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#D7E8C9',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: { enableStyle: false, background: '#FFFFFF' },
      },
    };
  },
  mounted() {
    const extract = this.sectionEditor.sectionExtract || {};
    this.fields = {
      ...this.fields,
      ...extract,
      image: { ...this.fields.image, ...(extract.image || {}) },
      settings: { ...this.fields.settings, ...(extract.settings || {}) },
      containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
      listItem: (extract.listItem || []).map(item => ({ ...defaultItem(), ...item })),
    };
  },
  methods: {
    handleAddItem() {
      this.fields.listItem.push(defaultItem());
    },
    handleRemoveItem(index) {
      this.fields.listItem.splice(index, 1);
    },
    handleUploadImage(obj) {
      this.fields.image.src = obj?.imageSrc || '';
    },
    handleRemoveImage() {
      this.fields.image.src = '';
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionUpairyTimeline(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', { ...this.sectionEditor.section, title: this.fields.title, html });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.editor-dialog {
  background-color: #fff;
}
::v-deep .ck-editor__editable_inline {
  min-height: 100px !important;
}
.label-input {
  display: block;
  margin-bottom: 10px;
  color: #000;
  font-size: 18px;
  font-weight: 500;
}
.group-item {
  padding: 15px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
}
.header-modal,
.footer-modal {
  position: sticky;
  left: 0;
  z-index: 999;
  padding: 0 16px;
  background: #fff;
  box-shadow: 0 0 12px #0000000f;
}
.header-modal {
  top: 0;
}
.footer-modal {
  bottom: 0;
}
</style>
